import React from 'react';

import { WithId } from '@common/typescript/objects/WithId';
import { MenuItem } from '@common/react/objects/MenuItem';

export enum SearchObjectType {
	Menu = 0,
	User = 1,
}

export type CustomItemDelegate<T extends number> = (params: {
	search: string,
	item: SearchObject<T>,
	menuItem: MenuItem,
	ref: any,
	onSelect?: (item: SearchObject<T>) => void,
	isSelected?: boolean,
	additional?: React.ReactNode,
	onClick?: (e, item: SearchObject<T>) => void,
}) => React.ReactNode;

export interface ResponseSearchObject<T extends number> extends WithId {
	type: T;
	firstName: string;
	lastName: string;
	avatar: string;
}

export interface SearchObject<T extends number> extends ResponseSearchObject<T> {
	menuItem?: MenuItem;
	path?: string;
	group?: boolean;
	scrollIntoView?: boolean;
	color?: string;
	transmutation?: boolean;
	additional?: React.ReactNode;
}
